// Itens do bloco de notícias com "pular" e "completar". Na notícia aberta, a
// lateral mostra as primeiras relacionadas (mesmo assunto) e o rodapé, as
// seguintes, sem repetir; faltando relacionadas, o rodapé completa com as mais
// recentes que ainda não apareceram na página.
export const comporComRecentes = ({
  itens = [],
  recentes = [],
  excluir = [],
  pular = 0,
  limite = Infinity,
  completar = false,
  caminho = (item) => item['@id'],
}) => {
  const fora = new Set(excluir);
  const proprios = itens.filter((item) => !fora.has(caminho(item)));
  const pulados = proprios.slice(0, pular);
  const escolhidos = proprios.slice(pular, pular + limite);
  if (!completar || escolhidos.length >= limite) {
    return { itens: escolhidos, completou: false };
  }
  const usados = new Set([
    ...fora,
    ...pulados.map(caminho),
    ...escolhidos.map(caminho),
  ]);
  const extras = recentes
    .filter((item) => !usados.has(caminho(item)))
    .slice(0, limite - escolhidos.length);
  return { itens: [...escolhidos, ...extras], completou: extras.length > 0 };
};

const assuntosDe = (item) => item.subjects || item.Subject || [];

// Lateral "Veja também" da notícia aberta (22/10/2026): as relacionadas vêm por
// assunto e são ordenadas pela afinidade, isto é, quantos assuntos têm em comum
// com a aberta. No empate fica a ordem da busca (a data, da mais nova para a
// mais antiga). Sem isso, um assunto amplo ("Atenção Especializada") enchia a
// lateral com as mais recentes dele e escondia as de assunto mais próximo.
export const ordenarPorAfinidade = (itens = [], assuntos = []) => {
  if (!assuntos.length) return itens;
  const alvo = new Set(assuntos);
  const pontos = (item) => assuntosDe(item).filter((s) => alvo.has(s)).length;
  return itens
    .map((item, ordem) => ({ item, ordem, pontos: pontos(item) }))
    .sort((a, b) => b.pontos - a.pontos || a.ordem - b.ordem)
    .map((x) => x.item);
};

// Rodapé "Notícias mais recentes" da notícia aberta: deixa de fora as que têm
// algum assunto em comum com a aberta, que são as da lateral.
export const semAssuntos = (itens = [], assuntos = []) => {
  if (!assuntos.length) return itens;
  const alvo = new Set(assuntos);
  return itens.filter((item) => !assuntosDe(item).some((s) => alvo.has(s)));
};
